import AgregarCliente from './AgregarCliente'

export default AgregarCliente
